import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3TimeSeriesEdit } from "./edit";
import { S3TimeSeriesNew } from "./new";
import { S3TimeSeriesTable } from "./table";

export default function S3TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3TimeSeriesEdit />} />
      <Route index element={<S3TimeSeriesTable />} />
      <Route path="/new" element={<S3TimeSeriesNew />} />
    </Routes>
  );
}
